import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import moment from 'moment-timezone';
import { Link } from 'react-router-dom';
import { cancelRequest } from '../../services/request.service';
import { sessionActionCreators } from '../../stores/lis-session-store';
import { memberActionCreators } from '../../stores/lis-members-store';
import { billActionCreators } from '../../stores/lis-legislation-store';
import BillInfoComponent from '../../lis-shared/lis-search/lis-bill-info';
import ReportMaker from './lis-bill-search/lis-report-maker';
import { collectionActionCreators } from '../../stores/lis-collection-store';
import { navActionCreators } from '../../stores/lis-nav-store';
import Select from 'react-select';
import { CustomOption } from '../../services/legislation-helper-service';

const selectStyle = {
    control: styles => ({
        ...styles,
        minHeight: '0px',
        padding: '0.12em 0.6em !important',
        borderColor: "#949494"
    }),
    valueContainer: styles => ({
        ...styles,
        padding: 0,
    }),
    input: styles => ({
        ...styles,
        fontSize: '0.8em',
        lineHeight: 'normal',
    }),
    singleValue: styles => ({
        ...styles,
        fontSize: '0.8em'
    }),
    placeholder: styles => ({
        ...styles,
        fontSize: '0.8em'
    }),
    option: styles => ({
        ...styles,
        fontSize: '0.8em'
    }),
    dropdownIndicator: styles => ({
        ...styles,
        padding: '1px',
        color: "#666666"
    }),
    clearIndicator: (base) => ({
        ...base,
        color: "#666666"
    }),
}

const BILL_COLLECTION_AUTHOR = "LegislationCollections";
//Add these to header based on patronTypeID in URL

const PATRON_TYPES = [
    {
        PatronTypeID: 1,
        Name: "Chief Patron",
    },
    {
        PatronTypeID: 2,
        Name: "Chief Co-Patron",
    },
    {
        PatronTypeID: 3,
        Name: "Incorporated Chief Co-Patron",
    },
    {
        PatronTypeID: 4,
        Name: "Co-Patron",
    },
    {
        PatronTypeID: 5,
        Name: "Sponsor",
    }
]

class PublicMemberLegislation extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            noResults: false,
            checkedBills: [],
            collections: [],
            results: [],
            memberData: '',
            sessionData: '',
            selectedWatchlists: [],
            loading: true,
            showPopup: false,
            showReportMaker: false,
            showWatchlistForm: false,
            checkAll: false,
            memberContact: '',
            newNote: {
                Name: '',
                WatchListID: -1,
                isNew: true,
                value: '',
                Description: ''
            },
            menuIsOpen: false,
        };

        this.addToWatchlists = this.addToWatchlists.bind(this);
        this.getMemberContact = this.getMemberContact.bind(this);
        this.handleAddToWatchlists = this.handleAddToWatchlists.bind(this);
        this.handleBillCheckbox = this.handleBillCheckbox.bind(this);
        this.handleWatchlistChange = this.handleWatchlistChange.bind(this);
        this.selectAll = this.selectAll.bind(this);
        this.setupPage = this.setupPage.bind(this);
        this.toggleShowData = this.toggleShowData.bind(this);
        this.toggleMenuIsOpen = this.toggleMenuIsOpen.bind(this);
        this.handleIsRelated = this.handleIsRelated.bind(this);
        this.manuallyFocusTheNextOne = this.manuallyFocusTheNextOne.bind(this);

        this.selectRef = React.createRef();
        this._billResultRefs = [];
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        //Update the session selector component, which will run componentDidUpdate and call setupDoc on its own
        const sessionCode = this.props.match.params.sessioncode
        if (sessionCode) {
            if (this.props.nav.session !== sessionCode && this.props.session.sessionList.length > 0) {
                this.props.actions.changeSession(sessionCode)
            } else {
                this.setupPage(sessionCode);
            }
        }
    }

    componentDidUpdate(prevProps) {
        // Setup the page if the global selected session changes. Change the URL to reflect the session change
        if (prevProps.nav.session !== this.props.nav.session) {
            this.props.history.push('/session-details/' + this.props.nav.session + '/member-information/' + this.props.match.params.membernumber + "/member-legislation-list/" + this.props.match.params.patrontype);
            this.setupPage(this.props.nav.session);
        } else if (this.props.nav.session !== this.props.match.params.sessioncode) {
            // If the url changes then update the global selected session with whatever the url is
            if (this.props.match.params.sessioncode) {
                this.props.actions.changeSession(this.props.match.params.sessioncode);
            }
        } else if (this.props.match.params.membernumber !== prevProps.match.params.membernumber) {
            this.setupPage(this.props.nav.session);
        }
    }

    componentWillUnmount() {
        cancelRequest();
    }

    addToWatchlists(watchlists, callback) {
        let billsToAdd = [];

        this.state.checkedBills.forEach((c, i) => {
            if (c) {
                billsToAdd.push(this.state.results[i])
            }
        });

        let duplicatedBills = [];
        watchlists.forEach(watchlist => {
            billsToAdd.forEach(bill => {
                if (watchlist.__isNew__) {
                    watchlist.Name = watchlist.label;
                    watchlist.Description = `Created on ${moment().tz().format('MM/DD/YYYY')}`;
                    watchlist.WatchListLegislation = [];
                    delete watchlist.label;
                    delete watchlist.__isNew__;
                    delete watchlist.value;
                }
                // Make sure the bill isn't already a part of the watchlist
                if (!watchlist.WatchListLegislation.find(leg => leg.LegislationID === bill.LegislationID) || watchlist.WatchListLegislation.find(leg => leg.LegislationID === bill.LegislationID).DeletionDate) {
                    watchlist.WatchListLegislation.push({
                        LegislationID: bill.LegislationID,
                        LegislationNumber: bill.LegislationNumber,
                        Sessions: [{ SessionID: bill.SessionID }],
                        WatchListID: watchlist.WatchListID,
                        Note: bill.Note
                    });
                } else {
                    duplicatedBills.push({ "Watchlist": watchlist.Name, "LegislationNumber": bill.LegislationNumber });
                }
            });
        })

        this.setState({
            collectionIsSaving: true
        }, () => {
            let collections = [...this.state.collections];
            this.props.actions.saveCollections({ WatchLists: watchlists })
                .then(() => {
                    let watchlistSave = [...this.props.collection.collectionSave];
                    let savedCollectionIndex;
                    watchlistSave.forEach(res => {
                        if (!collections.find(coll => coll.WatchListID === res.WatchListID)) {
                            collections.unshift(res);
                            savedCollectionIndex = 0;
                        } else {
                            savedCollectionIndex = collections.findIndex(coll => coll.WatchListID === res.WatchListID);
                            collections[savedCollectionIndex] = res;
                        }
                        res.WatchListLegislation = res.WatchListLegislation || [];
                        res.NotificationCriterias = res.NotificationCriterias || [];
                    })

                    this.setState({
                        collectionIsSaving: false,
                        collections: collections,
                        selectedCollection: watchlists.length === 1 ? collections[savedCollectionIndex] : this.state.selectedCollection,
                        selectedCollectionIndex: watchlists.length === 1 ? savedCollectionIndex : this.state.selectedCollectionIndex,
                        checkedBills: []
                    });
                    if (duplicatedBills.length) {
                        this.props.actions.makeToast([{ message: (new Set(duplicatedBills.map(b => b.LegislationNumber)).size === 1 ? (duplicatedBills[0].LegislationNumber + " is ") : "Multiple added bills were ") + "already in " + (watchlists.length === 1 ? "this watchlist. " : "one or more of these watchlists. ") + (watchlists.length === 1 ? ((billsToAdd.length - duplicatedBills.length) + " bills were added to your watchlist " + watchlists[0].Name) : "All other bills were added."), type: "warning", long: true }]);
                    } else {
                        this.props.actions.makeToast([{ message: (billsToAdd.length === 1 ? billsToAdd[0].LegislationNumber + " was " : billsToAdd.length + " bills were ") + "added to your watchlist" + (watchlists.length > 1 ? "s" : (" " + watchlists[0].Name)), type: "success" }]);
                    }
                    if (callback) {
                        callback(collections)
                    }
                }).catch(err => {
                    if (err === 'Aborted') {
                        return;
                    }
                    console.log(err)
                    this.setState({
                        collectionIsSaving: false
                    });
                    let message;
                    if (err && JSON.parse(err)) {
                        const errorMsg = JSON.parse(err).Name;
                        message = errorMsg && errorMsg.includes('Public users are') ? errorMsg : 'Save Failed'
                    } else {
                        message = "Save Failed";
                    }
                    this.props.actions.makeToast([{ message: message, type: "failure", long: message.includes('Public users are') }]);
                })
        });
    }

    getMemberContact(memberNumber, sessionId) {
        const params = 'sessionID=' + sessionId + '&memberNumber=' + memberNumber;
        this.props.actions.getMemberContact(params)
            .then(() => {
                this.setState({
                    memberContact: this.props.members.memberContactData[0]
                })
            })
    }

    handleAddToWatchlists() {
        this.addToWatchlists(this.state.selectedWatchlists, (saveResultCollections) => {
            let showPopup = { ...this.state.showPopup };
            let watchlists = [...this.state.selectedWatchlists];

            for (let i = 0; i < watchlists.length; i++) {
                const associatedWatchlist = saveResultCollections.find(c => c.WatchListID === watchlists[i].WatchListID);
                if (associatedWatchlist && associatedWatchlist.ModificationDate !== watchlists[i].ModificationDate) {
                    watchlists[i] = associatedWatchlist
                };
            }

            this.setState({ selectedWatchlists: watchlists, showPopup })
        });
    }

    handleBillCheckbox(billIndex, e) {
        let checkedBills = [...this.state.checkedBills];
        let lastCheckedBill = this.state.lastCheckedBill;
        if (e.nativeEvent.shiftKey && this.state.lastCheckedBill !== -1) {
            checkedBills = checkedBills.fill(false);
            for (let i = 0; i < Math.abs(billIndex - this.state.lastCheckedBill); i++) {
                const index = this.state.lastCheckedBill + i * (billIndex - this.state.lastCheckedBill) / Math.abs(billIndex - this.state.lastCheckedBill);
                checkedBills[index] = true;
            }
        } else {
            lastCheckedBill = !checkedBills[billIndex] ? billIndex : this.state.lastCheckedBill;
        }
        checkedBills[billIndex] = !checkedBills[billIndex]
        this.setState({
            checkedBills: checkedBills,
            lastCheckedBill: lastCheckedBill
        });
    }

    handleWatchlistChange(val) {
        this.setState({
            selectedWatchlists: val ? val : []
        });
    }

    selectAll() {
        let checkedAll = [];
        checkedAll.length = this.state.results.length;
        checkedAll.fill(!this.state.checkAll);

        this.setState({
            checkedBills: checkedAll,
            checkAll: !this.state.checkAll
        })
    }

    setupPage() {
        let getSessions, getMembers;

        if (this.props.session.sessionList.length === 0) {
            getSessions = this.props.actions.getSessionList()
                .then(() => {
                    return Promise.resolve();
                })
        }

        if (this.props.members.memberList.length === 0) {
            getMembers = this.props.actions.getMemberList('sessionCode=' + this.props.match.params.sessioncode)
                .then(() => {
                    return Promise.resolve();
                });
        }

        Promise.all([
            getSessions,
            getMembers
        ]).then(() => {
            let params = {
                MemberID: this.props.members.memberList.find(x => x.MemberNumber === this.props.match.params.membernumber).MemberID,
                PatronTypes: [this.props.match.params.patrontype],
                SessionID: this.props.session.sessionList.find(x => x.SessionCode === this.props.match.params.sessioncode).SessionID
            }

            this.props.actions.getLegislationIdsList(params).then(() => {
                let legislationIdsResponse = { ... this.props.bills.legislationIdsList };
                legislationIdsResponse.LegislationIds = legislationIdsResponse.LegislationIds.filter((item, pos) => legislationIdsResponse.LegislationIds.findIndex(i => i.LegislationNumber === item.LegislationNumber && i.SessionID === item.SessionID) === pos);

                if (legislationIdsResponse.LegislationIds) {
                    this.props.actions.getBillListByIds({ "LegislationIds": legislationIdsResponse.LegislationIds })
                        .then(() => {
                            this.setState({
                                results: this.props.bills.billListByIds,
                                memberData: this.props.members.memberList.find(x => x.MemberNumber === this.props.match.params.membernumber),
                                sessionData: this.props.session.sessionList.find(x => x.SessionCode === this.props.match.params.sessioncode),
                                loading: false
                            }, () => {
                                if (this.props.login.userClaims.resources.find(resource => resource === BILL_COLLECTION_AUTHOR)) {
                                    this.props.actions.getCollections("?SessionID=" + this.state.sessionData.SessionID)
                                        .then(() => {
                                            this.setState({
                                                collections: this.props.collection.collections
                                            })
                                        })
                                }

                                this.getMemberContact(this.state.memberData.MemberNumber, this.state.sessionData.SessionID)
                            })
                        });
                } else {
                    this.setState({
                        noResults: true
                    })
                }
            })
        })
    }

    toggleShowData(billID, bool) {
        if (bool === undefined) {
            this.setState(prevState => ({
                [billID]: !prevState[billID]
            }));
        } else {
            //not just toggling, we're explicitly setting (e.g. if searching by keyword, and a bill has been expanded, if the keyword search location changes to bill text,
            //don't just toggle all (which would reset that bill to false), set them all to true)
            this.setState({
                [billID]: bool
            })
        }
    }

    toggleMenuIsOpen(value) {
        if (value === undefined) {
            this.setState({ menuIsOpen: !this.state.menuIsOpen });
        } else {
            this.setState({ menuIsOpen: value });
        }
    }

    handleIsRelated(e, direction) {
        const relatedTarget = e.relatedTarget
        if (relatedTarget === null) {
            this.toggleMenuIsOpen(false);
        }
        const isParOfTheSelect = (el) => {
            let parent = el?.parentElement;
            if (parent) {
                if (parent.id === 'sr-watchlist-name-control-bad') {
                    return true;
                } else {
                    return isParOfTheSelect(parent);
                }
            } else {
                return false;
            }
        }
        const shouldClose = isParOfTheSelect(relatedTarget);
        if (shouldClose) {
            e.preventDefault();
            e.stopPropagation();
        }
        if (shouldClose && direction) {

        } else {
            this.toggleMenuIsOpen(shouldClose);
        }
    }

    manuallyFocusTheNextOne(direction) {
        // The id is different depending on where the Modal is ...
        const mainThing = document.getElementById('sr-watchlist-name-control-bad');
        mainThing?.getElementsByTagName('input')[0]?.focus();
        document.getElementById('react-select-3-input')?.focus();
        if (direction === 'down') {
            this.selectRef?.current?.select?.focusOption('down');
        } else if (direction === 'up') {
            this.selectRef?.current?.select?.focusOption('up');
        }
    }

    render() {
        return (
            <div className='member-legislation-list-wrapper'>
                {this.state.showReportMaker &&
                    <ReportMaker
                        toggleReportMaker={() => this.setState({ showReportMaker: !this.state.showReportMaker })}
                        selectedCollection={{
                            Name: 'Report on ' + this.state.memberData.MemberDisplayName + "'s legislation as " + PATRON_TYPES.find(x => x.PatronTypeID == this.props.match.params.patrontype).Name
                        }}
                        billList={[...this.state.results.filter((x, i) => this.state.checkedBills[i])]}
                        reportTitle={'Report on ' + this.state.memberData.MemberDisplayName + "'s legislation as " + PATRON_TYPES.find(x => x.PatronTypeID == this.props.match.params.patrontype).Name}
                        history={this.props.history}
                    />
                }
                {this.state.loading &&
                    <div className="spinner"></div>
                }
                {this.state.memberData !== "" && this.state.sessionData !== "" &&
                    <div className="generic-details-page public-details inner-grid">
                        <div className='member-legislation-list-header'>
                            <h2 style={{ borderBottom: "0" }}>{this.state.memberData.MemberDisplayName}<span style={{ marginLeft: "0.5em" }}>({this.state.memberData.PartyCode})</span></h2>
                            <div className="list-links">
                                <Link to={'/session-details/' + this.props.match.params.sessioncode + '/member-information/' + this.props.match.params.membernumber + '/member-details'}>Member Details</Link>
                                <Link to={'/vote-search/' + this.props.match.params.sessioncode + '/' + this.props.match.params.membernumber}>Votes</Link>
                            </div>
                        </div>
                        <div className="details-header">
                            {this.state.results.length > 0 &&
                                <div className="member-legislation-list-stats">
                                    <h3 style={{ marginTop: "10px" }}>{"Legislation as " + PATRON_TYPES.find(x => x.PatronTypeID == this.props.match.params.patrontype).Name}</h3>
                                    <span style={{ margin: '12px 5px 0', color: '#767676' }}>|</span>
                                    {this.state.memberContact.PrefiledCount &&
                                        <label style={{ fontSize: "14px", marginTop: "15px" }}>Prefiled: {this.state.memberContact.PrefiledCount}/Not Prefiled: {this.state.memberContact.NotPrefiledCount}/Total: {this.state.memberContact.PrefiledCount + this.state.memberContact.NotPrefiledCount}</label>
                                    }
                                </div>
                            }
                        </div>
                        {this.state.noResults && <p>No Legislation</p>}
                    </div>
                }
                <div className='member-legislation-list-controls'>
                    {this.state.results.length > 0 && this.props.login.userClaims.resources.find(resource => resource === BILL_COLLECTION_AUTHOR) &&
                        <div className='checkbox-container'>
                            <input type="checkbox" onClick={() => this.selectAll()} checked={this.state.checkAll} />
                            <label>Select All</label>
                        </div>
                    }
                    {this.props.login.userClaims.resources.find(resource => resource === BILL_COLLECTION_AUTHOR) &&
                        <>
                            <button style={{ marginLeft: "10px" }} className='button primary' onClick={() => this.setState({ showReportMaker: !this.state.showReportMaker })} disabled={!this.state.checkedBills.find(x => x)}>Create Report</button>
                            <button style={{ marginLeft: "10px" }} className='button primary' onClick={() => this.setState({ showWatchlistForm: !this.state.showWatchlistForm })} disabled={!this.state.checkedBills.find(x => x)}>{!this.state.showWatchlistForm ? "Add to Watchlist" : "Hide Watchlist Form"}</button>
                        </>
                    }
                </div>
                {this.props.login.userClaims.resources.find(resource => resource === BILL_COLLECTION_AUTHOR) && this.state.results.length > 0 && this.state.showWatchlistForm &&
                    <div className="dlas-forms collection-controls" style={{ marginBottom: "5px" }}>
                        <h4 style={{ margin: 0 }}>Add bills to one or more watchlists</h4>
                        <div className="inner-grid two">
                            <div>
                                <label id='add-watchlist-label' htmlFor="sr-watchlist-name-control-bad">Watchlist Name</label>
                                <Select
                                    aria-label="Watchlist Selector"
                                    ref={this.selectRef}
                                    id="sr-watchlist-name-control-bad"
                                    styles={selectStyle}
                                    options={[{ isNew: true }].concat(this.state.collections)}
                                    getOptionLabel={opt => opt.label || `${opt.Name} ${opt.Description && `- ${opt.Description}`}`}
                                    getOptionValue={opt => opt.value || opt.WatchListID}
                                    value={this.state.selectedWatchlists}
                                    onChange={e => { if (Array.isArray(e) && e.find(ee => ee.isNew)) { return null; } this.toggleMenuIsOpen(false); this.handleWatchlistChange(e) }}
                                    createOptionPosition="first"
                                    formatCreateLabel={input => <span>Create new: {input}</span>}
                                    isMulti
                                    classNamePrefix='no-width-dropdown-input'
                                    components={{ 'Option': CustomOption }}
                                    updateNew={this.handleWatchlistChange}
                                    toggleMenuIsOpen={this.toggleMenuIsOpen}
                                    menuIsOpen={this.state.menuIsOpen}
                                    onMenuOpen={e => { this.toggleMenuIsOpen(!this.state.menuIsOpen) }}
                                    onBlur={e => { this.handleIsRelated(e) }}
                                    onKeyDown={e => {
                                        if (e.key === 'Enter') {
                                            e.preventDefault();
                                            const arrowDownEvent = new KeyboardEvent('keydown', {
                                                key: 'ArrowDown',
                                                code: 'ArrowDown',
                                                keyCode: 40,
                                                which: 40,
                                                bubbles: true
                                            });
                                            e.currentTarget.dispatchEvent(arrowDownEvent);
                                        }
                                        // So, arrow keys let you navigate through the options. But we want to be able to auto tab into the new input.
                                        // This works for the most part, until you tab into the select initially. Then you need to focus on that specifically.
                                        if (e.key === 'Tab' && this.selectRef?.current?.select?.state?.focusedOption?.isNew) {
                                            e.preventDefault();
                                            document.getElementById('add-new')?.focus();
                                        } else if (['ArrowDown', 'ArrowUp'].includes(e.key)) {
                                            const current = this.selectRef?.current?.select?.state?.focusedOption?.WatchListID;
                                            const menuOptions = this.selectRef?.current?.select?.state?.menuOptions?.render;
                                            if (menuOptions && menuOptions.length > 1 && current) {
                                                const index = menuOptions.findIndex(o => o.data?.WatchListID === current);
                                                if (index === 1 && e.key === 'ArrowUp') {
                                                    this.selectRef?.current?.select?.focusOption('up');
                                                    setTimeout(() => document.getElementById('add-new')?.focus())
                                                } else if (index === menuOptions.length - 1 && e.key === 'ArrowDown') {
                                                    this.selectRef?.current?.select?.focusOption('down');
                                                    setTimeout(() => document.getElementById('add-new')?.focus())
                                                }
                                            } else if (menuOptions && this.selectRef?.current?.select?.state?.focusedOption === undefined && e.key === 'ArrowDown') {
                                                setTimeout(() => document.getElementById('add-new')?.focus())
                                            }
                                        }
                                    }}
                                    manuallyFocusTheNextOne={this.manuallyFocusTheNextOne}
                                    handleIsRelated={this.handleIsRelated}
                                />
                            </div>
                            <div className="inline-list">
                                <br />
                                {this.props.collectionIsSaving ?
                                    <div><span className="small-spinner"></span></div>
                                    :
                                    <React.Fragment>
                                        <button disabled={this.state.selectedWatchlists.length === 0} style={{ marginLeft: "0px" }} className="button" type="button" onClick={() => this.handleAddToWatchlists()}>Add</button>
                                    </React.Fragment>
                                }
                            </div>
                        </div>
                    </div>
                }
                <div className='member-legislation-list search-results'>
                    {this.state.results.map((bill, i) => {
                        return <BillInfoComponent
                            key={i}
                            ref={this._billResultRefs[i]}
                            userCanUseCollections={this.props.login.userClaims.resources.find(resource => resource === BILL_COLLECTION_AUTHOR) ? true : false}
                            bill={bill}
                            billIndex={i}
                            sessionID={this.props.session.sessionList.find(x => x.SessionCode === this.props.match.params.sessioncode).SessionID}
                            toggleShowData={this.toggleShowData}
                            expanded={this.state[bill.LegislationID]}
                            sessionCode={this.props.match.params.sessioncode}
                            selectedCollection={undefined}
                            handleCollectionChange={() => { }}
                            collectionIsSaving={() => { }}
                            handleBillCheckbox={e => this.handleBillCheckbox(i, e)}
                            checked={this.state.checkedBills[i]}
                            selectedKeywords={[]}
                            selectedLocation={undefined}
                            searchMade={false}
                            session={this.props.session.sessionList.find(x => x.SessionID === bill.SessionID)}
                            displayCrossSession={false}
                            newSession={false}
                            displayChapterNumber={false}
                            compositeView={false}
                        />
                    })}
                </div>
            </div>
        )
    }

}

export default connect(
    (state) => {
        const { bills, collection, login, members, nav, session } = state;
        return {
            bills,
            collection,
            login,
            members,
            nav,
            session
        }
    },
    (dispatch) => {
        return {
            actions: bindActionCreators(Object.assign({}, sessionActionCreators, memberActionCreators, billActionCreators, collectionActionCreators, navActionCreators), dispatch)
        }
    }
)(PublicMemberLegislation);
